import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";

const useTenantAssets = () => {
  const { metadata } = useContext(ThemeContext);

  const tenantConfig = {
    oneplacesolar: {
      logos: {
        navbar: "/images/Logo_1.png",
        login: "/images/Logo.png",
      }
    },
    reyzap: {
      logos: {
        navbar: "/images/reyzap-logo.png",
        login: "/images/reyzap.png",
      }
    },
  };

  const host = metadata?.name || "";

  const match = Object.keys(tenantConfig).find((key) =>
    host.includes(key)
  );

  const config = tenantConfig[match];

  const getLogo = (type = "navbar") => {
    return config?.logos?.[type];
  };

  return { getLogo };
};

export default useTenantAssets;